import Grid from "@mui/material/Grid";
import MDBox from "../../components/MDBox";
import Box from "@mui/material/Box";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
// import Projects from "./components/TopSellingProduct";
import OrdersOverview from "../../layouts/dashboard/components/OrdersOverview";
import { useEffect, useState } from "react";
import {
  dashboardApi,
  vipUsersApi,
  mostOrderedProductsApi,
  getYearSalesApi,
  previousAndCurrentOrderApi,
  mostVisitedProductsApi,
} from "../../store/api";
import { useNavigate } from "react-router";
import ApexChart from "react-apexcharts";
import Grid2 from "@mui/material/Unstable_Grid2";
import BarChart from "layouts/dashboard/components/BarChart";
import SummaryChart from "layouts/dashboard/components/SummaryChart";
import { CardHeader } from "@mui/material";
import TopSellingProduct from "./components/TopSellingProduct";
import TopVisitedProduct from "./components/TopVisitedProduct";

function Dashboard () {
  const navigate = useNavigate();
  const [sales, setSales] = useState("");
  const [users, setUsers] = useState("");
  const [vipUsers, setVIPUsers] = useState([]);
  const [topSellProduct, setTopSellProduct] = useState("");
  const [mostVisitedProduct, setMostVisitedProduct] = useState([]);
  const [yearSales, setYearSales] = useState([]);
  const [monthGraph, setMonthGraph] = useState([]);
  const [prevMonthGraph, setPrevMonthGraph] = useState([]);
  const [showGraph, setShowGraph] = useState(false);
  const [currentMonthGraph, setCurrentMonthGraph] = useState([]);
  const [products, setProducts] = useState("");

  const fillMissingDays = (data, daysInMonth = 31) => {
    const dayMap = new Map(data.map(item => [item.day, item]));

    const fullData = Array.from({ length: daysInMonth }, (_, i) => {
      const day = i + 1;
      return dayMap.get(day) || { day, currentMonthOrders: "0", previousMonthOrders: "0" };
    });

    return fullData;
  };
  function add (accumulator, a) {
    return accumulator + parseInt(a);
  }
  const FetchDashboardData = async () => {
    const response = await dashboardApi();
    const response1 = await vipUsersApi();
    const response2 = await mostOrderedProductsApi();
    const response3 = await getYearSalesApi();
    const response4 = await previousAndCurrentOrderApi();
    const response5 = await mostVisitedProductsApi();
    if (response?.success) {
      setSales(response?.data?.saleAnalytics);
      setUsers(response?.data?.userDetails);
      setProducts(response?.data?.productDetails);
    }
    if (response1?.success) {
      setVIPUsers(response1?.data);
    }
    if (response2?.success) {
      setTopSellProduct(response2?.data);
    }
    if (response3?.success) {
      setYearSales(response3?.data);
    }
    if (response4?.success) {
      let data = fillMissingDays(response4?.data);
      let sumCur = data.map(e => parseFloat(e.currentMonthOrders)).reduce(add, 0);
      let sumPrev = data.map(e => parseFloat(e.previousMonthOrders)).reduce(add, 0);
      let sum = sumCur + sumPrev;
      if (sum) {
        setShowGraph(true);
      }
      let currentMonth = data?.map(e => e.currentMonthOrders);
      let prevMonth = data?.map(e => e.previousMonthOrders);
      setCurrentMonthGraph(currentMonth);
      setPrevMonthGraph(prevMonth);
      setMonthGraph(data);
    }
    if (response5?.success) {
      setMostVisitedProduct(response5?.data);
    }
  };

  useEffect(() => {
    FetchDashboardData();
  }, []);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <div
          style={{ fontWeight: "700", color: "#344767", fontSize: "1.5rem", marginBottom: "40px" }}
        >
          Hi, Welcome back 👋
        </div>
        <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
          <div
            style={{
              width: "50%",
              borderRadius: "12px",
              boxShadow: "0 2px 10px 2px rgba(0,0,0,0.15)",
            }}
          >
            <CardHeader title='Number of Orders' />
            {showGraph ? (
              <SummaryChart
                monthGraph={monthGraph}
                prevMonthGraph={prevMonthGraph}
                currentMonthGraph={currentMonthGraph}
              />
            ) : (
              <div style={{ padding: "0 16px 10px", fontSize: "14px" }}>No Order Yet!</div>
            )}
          </div>
          <div
            style={{
              width: "50%",
              borderRadius: "12px",
              boxShadow: "0 2px 10px 2px rgba(0,0,0,0.15)",
              // height: "fit-content",
            }}
          >
            <BarChart yearSales={yearSales} />
          </div>
        </div>
        <MDBox style={{ fontWeight: "500", cursor: "pointer" }} onClick={() => navigate("/orders")}>
          Sales
        </MDBox>
        <Grid container py={3} spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5} style={{ cursor: "pointer" }} onClick={() => navigate("/orders")}>
              <Card
                title='Today sales'
                count={sales?.todayTotal}
                color={"#1877F2"}
                textColor={"#042174"}
                secondary={"rgba(115, 186, 251,0.48)"}
                secondaryLight={"rgba(208, 236, 254,0.48)"}
                image={"https://voltcapital.s3.eu-north-1.amazonaws.com/logo/ic-glass-bag.svg"}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5} style={{ cursor: "pointer" }} onClick={() => navigate("/orders")}>
              <Card
                title='This Week sales'
                count={sales?.weekTotal}
                color={"#1877F2"}
                textColor={"#042174"}
                secondary={"rgba(115, 186, 251,0.48)"}
                secondaryLight={"rgba(208, 236, 254,0.48)"}
                image={"https://voltcapital.s3.eu-north-1.amazonaws.com/logo/ic-glass-bag.svg"}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5} style={{ cursor: "pointer" }} onClick={() => navigate("/orders")}>
              <Card
                title='This Month sales'
                count={sales?.monthTotal}
                color={"#1877F2"}
                textColor={"#042174"}
                secondary={"rgba(115, 186, 251,0.48)"}
                secondaryLight={"rgba(208, 236, 254,0.48)"}
                image={"https://voltcapital.s3.eu-north-1.amazonaws.com/logo/ic-glass-bag.svg"}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5} style={{ cursor: "pointer" }} onClick={() => navigate("/orders")}>
              <Card
                title='This Year sales'
                count={sales?.yearTotal}
                color={"#1877F2"}
                textColor={"#042174"}
                secondary={"rgba(115, 186, 251,0.48)"}
                secondaryLight={"rgba(208, 236, 254,0.48)"}
                image={"https://voltcapital.s3.eu-north-1.amazonaws.com/logo/ic-glass-bag.svg"}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox style={{ fontWeight: "500", cursor: "pointer" }} onClick={() => navigate("/users")}>
          Users
        </MDBox>
        <Grid container py={3} spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5} style={{ cursor: "pointer" }} onClick={() => navigate("/users")}>
              <Card
                title='Today Users'
                count={users?.todayCount}
                color={"#27097A"}
                textColor={"#042174"}
                secondary={"rgba(198, 132, 255,0.48)"}
                secondaryLight={"rgba(239, 214, 255,0.48)"}
                image={"https://voltcapital.s3.eu-north-1.amazonaws.com/logo/ic-glass-users.svg"}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5} style={{ cursor: "pointer" }} onClick={() => navigate("/users")}>
              <Card
                title='This week users'
                count={users?.weekCount}
                color={"#27097A"}
                textColor={"#042174"}
                secondary={"rgba(198, 132, 255,0.48)"}
                secondaryLight={"rgba(239, 214, 255,0.48)"}
                image={"https://voltcapital.s3.eu-north-1.amazonaws.com/logo/ic-glass-users.svg"}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5} style={{ cursor: "pointer" }} onClick={() => navigate("/users")}>
              <Card
                title='This month users'
                count={users?.monthCount}
                color={"#27097A"}
                textColor={"#042174"}
                secondary={"rgba(198, 132, 255,0.48)"}
                secondaryLight={"rgba(239, 214, 255,0.48)"}
                image={"https://voltcapital.s3.eu-north-1.amazonaws.com/logo/ic-glass-users.svg"}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5} style={{ cursor: "pointer" }} onClick={() => navigate("/users")}>
              <Card
                title='This year users'
                count={users?.yearCount}
                color={"#27097A"}
                textColor={"#042174"}
                secondary={"rgba(198, 132, 255,0.48)"}
                secondaryLight={"rgba(239, 214, 255,0.48)"}
                image={"https://voltcapital.s3.eu-north-1.amazonaws.com/logo/ic-glass-users.svg"}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox style={{ fontWeight: "500" }}>Inventry</MDBox>
        <Grid container py={3} spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <Card
                title='Total Products Counts'
                count={products?.productInventory}
                color={"#FFAB00"}
                textColor={"#7A4100"}
                secondary={"rgba(255, 214, 102,0.48)"}
                secondaryLight={"rgba(255, 245, 204,0.48)"}
                image={"https://voltcapital.s3.eu-north-1.amazonaws.com/logo/ic-glass-buy.svg"}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox
          style={{ fontWeight: "500", cursor: "pointer" }}
          onClick={() => navigate("/category")}
        >
          Category
        </MDBox>
        <Grid container py={3} spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5} style={{ cursor: "pointer" }} onClick={() => navigate("/category")}>
              <Card
                title='Total Category'
                count={products?.totalCategory}
                color={"#1ca66c"}
                textColor={"#00473a"}
                secondary={"rgba(109, 251, 196,0.4)"}
                secondaryLight={"rgba(170, 244, 205,0.2)"}
                image={"https://voltcapital.s3.eu-north-1.amazonaws.com/logo/ic-glass-buy-i.svg"}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5} style={{ cursor: "pointer" }} onClick={() => navigate("/category")}>
              <Card
                title='Active Category'
                count={products?.activeCategory}
                color={"#1ca66c"}
                textColor={"#00473a"}
                secondary={"rgba(109, 251, 196,0.4)"}
                secondaryLight={"rgba(170, 244, 205,0.2)"}
                image={"https://voltcapital.s3.eu-north-1.amazonaws.com/logo/ic-glass-buy-i.svg"}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox
          style={{ fontWeight: "500", cursor: "pointer" }}
          onClick={() => navigate("/products")}
        >
          Products
        </MDBox>
        <Grid container py={3} spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5} style={{ cursor: "pointer" }} onClick={() => navigate("/products")}>
              <Card
                title='Total Products'
                count={products?.totalProduct}
                color={"rgb(248, 187, 5)"}
                textColor={"#a67d03"}
                secondary={"rgba(232, 196, 88, 0.1)"}
                secondaryLight={"rgba(242, 248, 113, .80)"}
                image={
                  "https://voltcapital.s3.eu-north-1.amazonaws.com/logo/ic-glass-buy-product.svg"
                }
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5} style={{ cursor: "pointer" }} onClick={() => navigate("/products")}>
              <Card
                title='Active Products'
                count={products?.activeProduct}
                color={"rgb(248, 187, 5)"}
                textColor={"#a67d03"}
                secondary={"rgba(232, 196, 88, 0.1)"}
                secondaryLight={"rgba(242, 248, 113, .80)"}
                image={
                  "https://voltcapital.s3.eu-north-1.amazonaws.com/logo/ic-glass-buy-product.svg"
                }
              />
            </MDBox>
          </Grid>
        </Grid>
        {/* <Grid container py={3} spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color='dark'
                icon='store'
                title='Total category'
                count={281}
                percentage={{
                  color: "success",
                  amount: "+55%",
                  label: "than lask week",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon='store'
                title='Total products'
                count='2,300'
                percentage={{
                  color: "success",
                  amount: "+3%",
                  label: "than last month",
                }}
              />
            </MDBox>
          </Grid>
        </Grid> */}
        <MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <TopSellingProduct topSellProduct={topSellProduct} />
            </Grid>
            <Grid style={{ height: "fit-content" }} item xs={12} md={6} lg={6}>
              <TopVisitedProduct mostVisitProduct={mostVisitedProduct} />
            </Grid>
          </Grid>
        </MDBox>
        <MDBox>
          <Grid container spacing={3} mt={3}>
            <Grid style={{ height: "fit-content" }} item xs={12}>
              <OrdersOverview vipUsers={vipUsers} />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default Dashboard;

const Card = ({ title, count, color, secondary, secondaryLight, textColor, image }) => {
  const chart = {
    chart: {
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      parentHeightOffset: 0,
      sparkline: {
        enabled: true,
      },
      animations: {
        enabled: false,
        speed: 360,
        animateGradually: {
          enabled: true,
          delay: 120,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 360,
        },
      },
    },
    colors: [color],
    xaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      categories: [],
      type: "numeric",
      labels: {},
      tickAmount: "dataPoints",
    },
    grid: {
      strokeDashArray: 3,
      borderColor: color,
      padding: {
        top: 6,
        right: 6,
        bottom: 6,
        left: 6,
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    tooltip: {
      enabled: false,
      theme: "false",
      fillSeriesColor: false,
      x: {
        show: true,
      },
      y: {
        title: {},
      },
    },
    states: {
      // hover: {
      //   filter: {
      //     type: "darken",
      //     value: 0.88,
      //   },
      // },
      // active: {
      //   filter: {
      //     type: "darken",
      //     value: 0.88,
      //   },
      // },
    },
    fill: {
      opacity: 1,
      gradient: {
        type: "vertical",
        shadeIntensity: 0,
        opacityFrom: 0.4,
        opacityTo: 0,
        stops: [0, 50],
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2.5,
      curve: "smooth",
      lineCap: "round",
    },
    yaxis: {
      tickAmount: 5,
    },
    markers: {
      size: 0,
      strokeColors: color,
    },
    legend: {
      show: false,
      position: "top",
      fontWeight: 500,
      fontSize: "13px",
      horizontalAlign: "right",
      markers: {
        shape: "circle",
      },
      labels: {
        colors: "#344767",
      },
      itemMargin: {
        horizontal: 8,
        vertical: 8,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: "48%",
        borderRadiusApplication: "end",
      },
      pie: {
        donut: {
          labels: {
            show: true,
            value: {
              offsetY: 8,
              color: color,
              fontSize: "1.25rem",
              fontWeight: 700,
            },
            total: {
              show: true,
              label: "Total",
              color: color,
              fontSize: "0.875rem",
              fontWeight: 600,
            },
          },
        },
      },
      radialBar: {
        hollow: {
          margin: -8,
          size: "100%",
        },
        track: {
          margin: -8,
          strokeWidth: "50%",
          background: color,
        },
        dataLabels: {
          value: {
            offsetY: 8,
            color: color,
            fontSize: "1.25rem",
            fontWeight: 700,
          },
          total: {
            show: true,
            label: "Total",
            color: "white",
            fontSize: "0.875rem",
            fontWeight: 600,
          },
        },
      },
      radar: {
        polygons: {
          fill: {
            colors: ["transparent"],
          },
          strokeColors: color,
          connectorColors: color,
        },
      },
      polarArea: {
        rings: {
          strokeColor: color,
        },
        spokes: {
          connectorColors: color,
        },
      },
      heatmap: {
        distributed: true,
      },
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          plotOptions: {
            bar: {
              borderRadius: 3,
              columnWidth: "80%",
            },
          },
        },
      },
      {
        breakpoint: 900,
        options: {
          plotOptions: {
            bar: {
              columnWidth: "60%",
            },
          },
        },
      },
    ],
  };
  return (
    <Grid2 xs={6} sm={6} md={3}>
      <div
        style={{
          borderRadius: "16px",
          overflow: "hidden",
          background: "none",
          position: "relative",
          height: "240px",
        }}
      >
        <div className='css-1nu6oj6' style={{ backgroundColor: color, color: color }}></div>
        <div
          style={{
            width: "100%",
            height: "100%",
            background: `linear-gradient(135deg, ${secondaryLight}, ${secondary})`,
            position: "absolute",
            zIndex: "2",
          }}
        ></div>
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            zIndex: "3",
            padding: "24px",
          }}
        >
          {/* <Box
            sx={{
              top: 16,
              gap: 0.5,
              right: 16,
              display: "flex",
              position: "absolute",
              alignItems: "center",
            }}
          >
            <Box
              component={Icon}
              icon={"eva:trending-down-fill"}
              sx={{
                width: 10,
                height: 10,
                flexShrink: 0,
                display: "inline-flex",
              }}
            />
            <Box component='span' sx={{ typography: "subtitle2" }}>
              0
            </Box>
          </Box> */}

          <Box sx={{ width: 48, height: 48, mb: 3 }}>
            <img alt='icon' src={image} />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "flex-end",
              justifyContent: "flex-end",
            }}
          >
            <Box sx={{ flexGrow: 1, minWidth: 112 }}>
              <Box
                sx={{ mb: 0, mt: 2, fontWeight: "bold", fontSize: "0.875rem", color: textColor }}
              >
                {title}
              </Box>
              <Box
                sx={{ fontSize: "1.5rem", lineHeight: "1.5", fontWeight: "700", color: textColor }}
              >
                {count ? count : 0}
              </Box>
            </Box>
          </Box>
          <Chart
            type='line'
            series={[
              {
                data: [100, -50, 100],
              },
            ]}
            options={chart}
            width={84}
            height={56}
            style={{ position: "absolute", right: "24px", bottom: "24px" }}
          />
        </div>
      </div>
    </Grid2>
  );
};

const Chart = ({ sx, type, series, height, options, width = "100%", ...other }) => {
  return (
    <Box
      dir='ltr'
      className={"mnl__icon__root"}
      sx={{
        width: 84,
        height: 56,
        flexShrink: 0,
        borderRadius: 1.5,
        position: "relative",
        ...sx,
      }}
      {...other}
    >
      <ApexChart type={type} series={series} options={options} width='100%' height='100%' />
    </Box>
  );
};
